<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-form
          @submit="onSubmit"
          @reset="onReset"
          class="q-gutter-sm">
        <q-input
            filled
            hide-bottom-space
            no-error-icon
            v-model="product.title"
            label="عنوان کالا که می تواند عنوان کامل و یا بخشی از عنوان کالا باشد"
            lazy-rules
            hide-hint
            :rules="[val=> val && val.length>0 || 'برای جستجو در بانک اطلاعاتی کالا وارد نمودن عنوان کالا الزامی است.']"
        >
          <template v-slot:append>
            <q-btn flat type="button" icon="group_work"
                   round
                   color="primary" @click="groupListDialog=true">
              <q-tooltip>
                گروه کالا
              </q-tooltip>
            </q-btn>
            <q-btn round flat type="button" @click="onSubmit" icon="search" color="primary"/>
            <q-btn round flat type="button" @click="onQrSearch" icon="qr_code_scanner" color="primary"/>
            <q-btn round type="reset" icon="search_off" color="red" flat class="q-ml-sm"
                   @click="$emit('cancel-product-search')"/>
          </template>
        </q-input>
        <q-chip v-if="selectedGroup" :label="selectedGroup.Group_Name" square icon="close" clickable
                @click="removeGroup">
          <q-toolbar>
            جستجو بر اساس بارکد
          </q-toolbar>
        </q-chip>
      </q-form>
    </q-card-section>

    <q-dialog maximized v-model="groupListDialog">
      <q-card flat>
        <q-card-section class="no-padding">
          <q-banner inline-actions class="bg-blue text-white">
            گروه کالاها
            <template v-slot:action>
              <q-btn icon="close" flat round v-close-popup/>
            </template>
          </q-banner>
        </q-card-section>
        <q-card-section class="no-padding">
          <GroupSimpleList @group-selected="groupSelected" :customer-info="customerInfo"/>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="qrScannerDialog">
      <QRScanner />
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from 'vuex';
import EventBus from "@/event-bus";
import QRScanner from "@/components/generals/QRScanner.vue";
import GroupSimpleList from "@/components/productInfo/GroupSimpleList.vue";

export default {
  name: "ProductInfoSearchPanel",
  components: {GroupSimpleList, QRScanner},
  props: {
    canSelectGroup: {
      type: Boolean,
      default: false
    },
    customerInfo: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      groupListDialog: false,
      selectedGroup: '',
      qrScannerDialog: false,
      product: {
        title: null
      }
    }
  },
  methods: {
    ...mapActions({
      getProductListBuGroupID: 'Products/getByGroupID',
      getProductTitle: 'Products/getByTitle'
    }),
    onQrSearch() {
      this.qrScannerDialog = true
    },
    removeGroup() {
      this.selectedGroup = '';
      EventBus.$emit('invoke-productinfo-search-result-event', []);
    },
    onSubmit() {
      this.getProductTitle({
        title: this.product.title,
        group_Id: this.selectedGroup ? this.selectedGroup.Group_ID : ''
      }).then((data) => {
        EventBus.$emit('invoke-productinfo-search-result-event', data);
      });
    },
    onReset() {
      this.product.title = null;
      EventBus.$emit('invoke-productinfo-search-result-event', []);
    },
    ...mapActions({
      getProductTitle: 'Products/getByTitle'
    }),
    groupSelected(args) {
      this.getProductListBuGroupID(args.Group_ID).then((res) => {
        EventBus.$emit('invoke-productinfo-search-result-event', res);
        EventBus.$emit('invoke-group-selected-event', args);
      })
    }
  },
  mounted() {
    EventBus.$on('invoke-group-selected-event', payload => {
      this.selectedGroup = payload
    });
  },
  meta() {
    return {
      title: "بانک اطلاعاتی محصولات"
    }
  }
}
</script>

<style scoped>

</style>
